export function GetMockDeveloperRead() {
  return {
    id: 1,
    name: "Sage - L&NH",
    contactName: "Alexander Scott",
    contactEmail: "Alexander.Scott@justmortgages.co.uk",
    contactAddress: null,
    contactTown: null,
    contactCounty: null,
    contactPostcode: null,
    primaryPhone: "07587038943 ",
    secondaryPhone: null,
    isDeleted: 0,
    createdDate: "2022-01-31T13:56:25.1842422",
    updatedDate: "2022-06-09T19:38:25.3604659",
    developerCode: "SAG",
    addedByUserId: 4,
    updatedByUserId: 47,
  };
}
